import { render, staticRenderFns } from "./NinjaList.vue?vue&type=template&id=a7b52410&scoped=true&"
import script from "./NinjaList.vue?vue&type=script&lang=js&"
export * from "./NinjaList.vue?vue&type=script&lang=js&"
import style0 from "./NinjaList.vue?vue&type=style&index=0&id=a7b52410&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b52410",
  null
  
)

export default component.exports